import React from 'react';
import styled from 'styled-components';
import { DeckType } from '../../../domain/entities/Room';
import { TokenSet } from '../../styles/tokens';
import { useLanguage } from '../../contexts/LanguageContext';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Label = styled.span<{ tokens: TokenSet }>`
  font-size: 12px;
  font-weight: 600;
  color: ${p => p.tokens.textMuted};
`;

const Group = styled.div<{ tokens: TokenSet }>`
  display: inline-flex;
  background: ${p => p.tokens.bgElevated};
  border: 1px solid ${p => p.tokens.border};
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
`;

const Segment = styled.button<{ active: boolean; tokens: TokenSet }>`
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 8px;
  transition: background 0.15s, color 0.15s;
  background: ${p => p.active ? p.tokens.primary : 'transparent'};
  color: ${p => p.active ? '#fff' : p.tokens.textMuted};
  &:hover:not(:disabled) {
    color: ${p => p.active ? '#fff' : p.tokens.text};
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

interface DeckSelectorProps {
  currentDeck: DeckType;
  onChange: (deck: DeckType) => void;
  disabled?: boolean;
  tokens: TokenSet;
}

export const DeckSelector: React.FC<DeckSelectorProps> = ({ currentDeck, onChange, disabled, tokens }) => {
  const { t } = useLanguage();
  return (
    <Wrapper>
      <Label tokens={tokens}>{t.deck.selectorLabel}</Label>
      <Group tokens={tokens} role="radiogroup" aria-label={t.deck.selectorLabel}>
        <Segment
          tokens={tokens}
          active={currentDeck === 'fibonacci'}
          disabled={disabled}
          onClick={() => onChange('fibonacci')}
          role="radio"
          aria-checked={currentDeck === 'fibonacci'}
          type="button"
        >
          {t.deck.fibonacci}
        </Segment>
        <Segment
          tokens={tokens}
          active={currentDeck === 'tshirt'}
          disabled={disabled}
          onClick={() => onChange('tshirt')}
          role="radio"
          aria-checked={currentDeck === 'tshirt'}
          type="button"
        >
          {t.deck.tshirt}
        </Segment>
      </Group>
    </Wrapper>
  );
};
